import styled, { keyframes } from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const growUpKeyFrame = keyframes`
  0% { transform: scale(.8); }
  80% { transform: scale(1.25);}
  100% {transform: scale(1);}
`;

export const $CardContentHistoryWrapper = styled.div`
  flex: 0;
  display: flex;
  flex-direction: row;
  flex-flow: column;
  margin-top: ${spacing('xxs')};

  @media ${media.maxWidth.xs} {
    width: 100%;
  }
`;

export const $CardContentHistory = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const $CardContentHistoryBlankSpace = styled.div`
  width: ${spacing(12)};
`;

export const $CardContentHistorySmallLine = styled.div`
  width: ${spacing('xxl')};
`;

export const $CardContentHistoryPoint = styled.div<{
  active?: boolean;
  disabled?: boolean;
}>`
  z-index: 1;
  width: ${spacing('lg')};
  height: ${spacing('lg')};
  border-radius: 50%;
  animation: ${growUpKeyFrame} 0.5s linear;
  animation-delay: 0.5s;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.tertiary : theme.colors.primary};
  ${({ active, theme }) =>
    active
      ? `box-shadow: 0 0 ${spacing('sm')} ${theme.colors.primary};`
      : 'animation: none;'}
`;

export const $CardContentHistoryLine = styled.div<{ disabled?: boolean }>`
  flex: 4;
`;

export const $CardContentHistoryDashedLine = styled.svg<{
  disabled?: boolean;
  isDashed?: boolean;
  isFirst?: boolean;
}>`
  stroke-width: 2px;

  & line {
    stroke: ${({ theme, isFirst, disabled }) => {
      if (isFirst) {
        return 'transparent';
      }
      if (disabled) {
        return theme.colors.tertiary;
      }

      return theme.colors.primary;
    }};
    stroke-dasharray: ${({ isDashed }) => (isDashed ? '10 4' : '1 0')};
  }
`;

export const $CardContentHistoryLegendWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
`;

export const $CardContentHistoryLegend = styled.div<{
  disabled?: boolean;
  active?: boolean;
}>`
  width: ${spacing(44)};
  margin: ${spacing('xs')} 0;
  display: flex;
  flex-direction: row;
  flex-flow: column;
  align-items: center;
  text-align: center;
  padding: 0 ${spacing('xs')};
  ${fontStyle('xs')};
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.tertiary : theme.colors.primary};
`;

export const $Divider = styled.div`
  width: calc(100% + ${spacing(7)});
  height: ${spacing('px')};
  background: ${({ theme }) => theme.colors.default};
  margin: ${spacing('lg')} -1rem ${spacing(5)};
`;
